import React, { useState } from 'react';
import SignupTextField, { SignupTextFieldProps } from './SignupTextField';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'store/hooks';
import { signSetAction } from '../../../store/signup/actions';
import { SignupState } from '../../../store/signup/types';
import { useNavigate } from 'react-router';
import { AppState } from '../../../store';
import { pushEvent } from '../../../utils/clevertapUtils';
import { CLICK_SKIP } from '../../../utils/clevertapEvents';

export const noValidation = (value: string | undefined): boolean => true;
export const minimumValidation = (value: string | undefined): boolean =>
    !!value;

export const simpleValidation = (value: string | undefined): boolean =>
    !!value && value.length > 1;

export interface SimpleTextFieldComponentProps {
    nextLink: string;
    isOptional?: true;
    reduxKey: keyof SignupState;
    placeholderText: string;
    errorText?: string;
    nullErrorText?: string;
    type: SignupTextFieldProps['type'];
    maxLength: number;
    requestState?: SignupTextFieldProps['requestState'];
    onSubmit?: (value?: string) => unknown;
    validation: (value: string | undefined) => boolean;
}

const SimpleTextFieldComponent: React.FC<SimpleTextFieldComponentProps> = ({
    nextLink,
    reduxKey,
    errorText,
    nullErrorText,
    isOptional,
    placeholderText,
    requestState,
    type,
    maxLength,
    onSubmit,
    validation,
}) => {
    const dispatch = useAppDispatch();
    const push = useNavigate();
    const defaultValue = useSelector(
        (state: AppState) => state.Signup[reduxKey],
    );
    const [value, setValue] = useState<string>(defaultValue?.toString() || '');
    const onChange = (value: string) => {
        setValue(value);
    };
    const onSubmitFunc = () => {
        if (!value && !isOptional) return;
        dispatch(
            signSetAction({
                [reduxKey]: value,
            }),
        );
        push(nextLink);
    };
    const onSkip = () => {
        pushEvent(CLICK_SKIP, { key: reduxKey });
        dispatch(
            signSetAction({
                [reduxKey]: '',
            }),
        );
        push(nextLink);
    };
    const submit = onSubmit ? () => onSubmit(value) : onSubmitFunc;
    return (
        <SignupTextField
            requestState={requestState}
            value={value}
            isFocus={true}
            isOptional={isOptional}
            type={type}
            errorText={errorText}
            nullErrorText={nullErrorText}
            placeholder={placeholderText}
            onChange={onChange}
            onSkip={onSkip}
            onSubmit={submit}
            validation={validation}
            maxLength={maxLength}
        />
    );
};

export default SimpleTextFieldComponent;
